module.exports = __webpack_public_path__ + "static/media/image6.b2a5abeb.PNG";